import React from 'react';
import { Button } from 'antd';
import classnames from 'classnames';

import { RequestUserTypeTabsProps, RequestTabsUserProps } from 'types/requests';
import './Tabs.scss';

const Tabs = (props: RequestUserTypeTabsProps) => {
  const {
    currentUserTab,
    setCurrentPage,
  } = props;

  const {
    setCurrentUserTypeTab,
  } = props.actions

  const userTypeTabs: RequestTabsUserProps[] = ['all', 'startup', 'angel-investor', 'venture-builder'];

  const tabTitles: Record<RequestTabsUserProps, string> = {
    all: 'All',
    startup: 'Startup',
    'angel-investor': 'Angel Investors',
    'venture-builder': 'Venture Builders',
  };

  const handleOnTabChange = (value: RequestTabsUserProps) => {
    setCurrentPage(1);
    setCurrentUserTypeTab({ currentUserTab: value });
  }

  return (
    <div className="tab-buttons-lg">
      {userTypeTabs.map((tab) => (
        <Button
          key={tab}
          className={classnames('tab-button-lg', { 'tab-button-active': currentUserTab === tab })}
          onClick={() => handleOnTabChange(tab)}
        >
          {tabTitles[tab]}
        </Button>
      ))}
    </div>
  );
}

export default Tabs;
